import apiClient from './apiClient';

export const getLimitDeviation = async ({
  system,
  type,
  position,
  grade,
  diameter,
  includeAdjacent,
}, options = {}) => {
  const response = await apiClient.get('/tolerances/limit-deviations', {
    params: {
      system,
      type,
      position,
      grade,
      diameter,
      includeAdjacent,
    },
    signal: options.signal,
  });

  return response.data;
};

export const getFit = async ({ system, diameter, hole, shaft }, options = {}) => {
  const response = await apiClient.get('/tolerances/fits', {
    params: { system, diameter, hole, shaft },
    signal: options.signal,
  });

  return response.data;
};

export const findFits = async (params, options = {}) => {
  const response = await apiClient.get('/tolerances/fit-finder', {
    params,
    signal: options.signal,
  });

  return response.data;
};

export const getRecommendedFits = async ({ system, category } = {}, options = {}) => {
  const response = await apiClient.get('/tolerances/recommended-fits', {
    params: { system, category },
    signal: options.signal,
  });

  return response.data;
};

export const getGauge = async ({
  diameter,
  tolerance,
  manufacturingCapabilityUm,
}, options = {}) => {
  const response = await apiClient.get('/tolerances/gauges', {
    params: { diameter, tolerance, manufacturingCapabilityUm },
    signal: options.signal,
  });
  return response.data;
};

export const calculateReamer = async (input, options = {}) => {
  const response = await apiClient.post('/tolerances/reamer-calculator', input, {
    signal: options.signal,
  });
  return response.data;
};
